import Immutable, { Record } from 'immutable';

const SubSkillResultRecord = Record({
  subSkillId: undefined,
  currentResultAbilityId: undefined,
  previousResultAbilityId: undefined,
});

class SubSkillResult extends SubSkillResultRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'subSkillId':
    case 'currentResultAbilityId':
    case 'previousResultAbilityId':
      return [key, `${val}`];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

SubSkillResult.create = (data) =>
  new SubSkillResult(data).mapEntries(reviver);

export default SubSkillResult;



// WEBPACK FOOTER //
// ./data/ProgressTests/StudentProgressTestResults/SkillResults/SubSkillResults/model.js